<template>
  <div class="order-item">
    <div class="generate-order-container">
      <e-search
              :count="100"
              :data="filterInfo.data"
              :field-list="filterInfo.fieldList"
              :list-type-info="listTypeInfo"
              :width="filterInfo.width"
              @handleFilter="handleFilter"
              @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="generate-order-top">
      <div class="generate-order-top-left">
        <div class="generate-order-top-left-input">
          <div>采购申请明细</div>
        </div>
        <div class="generate-order-top-left-sort" @click="sortChange">
          <div>按接收时间排序</div>
          <img v-show="!isSort" src="@/assets/img/purchase/up copy.png" alt="" />
          <img v-show="isSort" src="@/assets/img/purchase/down copy.png" alt="" />
        </div>
      </div>
    </div>
    <div v-for="(item, index) in myPurchaseRequestData" class="generate-order-main" :key="index">
      <div class="order-item">
        <div class="order-item-main">
          <div class="order-item-left">
            {{ index + 1 }}
          </div>
          <div class="order-item-middle">
            <ul>
              <li>
                <div class="text" :class="{ isActive: checked }">采购申请号：</div>
                <el-tooltip class="item" effect="dark" :content="item.purchaseRequisitionCode" placement="top"
                            v-if="item.purchaseRequisitionCode && item.purchaseRequisitionCode.length > 6">
                  <div>{{ item.purchaseRequisitionCode.substring(0,7)}}...</div>
                </el-tooltip>
              </li>
              <li>
                <div class="text" :class="{ isActive: checked }">商品行号：</div>
                <div class="text-value">{{ item.lineNumber }}</div>
              </li>
              <li>
                <div class="text" :class="{ isActive: checked }">商品名称：</div>

                <el-tooltip class="item" effect="dark" :content="item.productName" placement="top">
                  <div class="text-value text-value-number ellipsis">{{ item.productName }}</div>
                </el-tooltip>
                <!--                <div class="text-value text-value-number ellipsis">{{ item.productName }}</div>-->
              </li>
              <li class="li-width-196">
                <div class="text" :class="{ isActive: checked }">商品规格：</div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.productOptions"
                  placement="top"
                >
                  <span class="text-width-150 ellipsis text-value">{{ item.productOptions }}</span>
                </el-tooltip>
              </li>
              <li>
                <div class="text " :class="{ isActive: checked }">状态：</div>
                <div class="text-value text-value-number ellipsis">{{ item.deleteStatusName }}</div>
              </li>

              <li>
                <div class="text" :class="{ isActive: checked }">期望到货时间：</div>
                <div class="text-value">
                  <el-tooltip class="item" effect="dark" :content="item.expectedArrivalDate.split(' ')[0]" placement="top"
                              v-if="item.expectedArrivalDate">
                    <div >{{ item.expectedArrivalDate.split(' ')[0].substring(0,6)}}...</div>
                  </el-tooltip>
                </div>
              </li>

              <li>
                <div class="text text100" :class="{ isActive: checked }">平台接收时间：</div>
                <el-tooltip class="item" effect="dark" :content="item.createTime" placement="top">
                  <div class="text-value t-132">{{ item.createTime }}</div>
                </el-tooltip>
              </li>

              <li>
                <div class="text" :class="{ isActive: checked }" style="margin-left: 10px">
                  应采数量：
                </div>
                <div class="text-value">{{ item.requiredQuantity }}</div>
              </li>

              <li>
                <div class="text" :class="{ isActive: checked }">剩余应采数量：</div>
                <div class="text-value ellipsis">
                  {{ item.remainingQuantity != null ? item.remainingQuantity : item.intqty }}
                </div>
              </li>
              <li>
                <div class="text" :class="{ isActive: checked }"></div>
                <div class="text-value text-value-number ellipsis"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-if="noDataFlag" class="no-data">
      <!-- <img src="~/assets/images/orderDetail/order-no.png" alt="" /> -->
      <p>贵公司当前暂无采购申请跟踪</p>
      <!-- <p>
        请
        <span @click="toSelect">选择商品</span>
        下单
      </p> -->
    </div>
    <!-- 分页 -->
    <div class="pagination-box" v-if="!noDataFlag">
      <el-pagination
              style="margin-top: 20px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :pager-count="5"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="formInline.page"
              :total="formInline.total"
              :page-size.sync="formInline.limit"
              prev-text="上一页"
              next-text="下一页"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/purchase';
import eSearch from '../../../components/common/e-search';
export default {
  name: 'order-item',
  components:{eSearch},
  props: {
    setCurrentMenu: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      filterInfo: {
        data: {
          purchaseRequisitionCode:null,
          trackStatus:null,
          productName:null,
          materielCode:null,
        },
        fieldList: [
          {label: '采购申请号', type: 'input', value: 'purchaseRequisitionCode',},
          {label: '企业物料编码', type: 'input', value: 'materielCode',},
          {label: '状态', type: 'select', value: 'trackStatus', list: 'trackStatusList',},
          {label: '商品名称', type: 'input', value: 'productName',},

        ],
        width: {
          labelWidth: 130,
          itemWidth: 160,
        },
      },
      listTypeInfo: {
        trackStatusList: [
          {id: null, name: '全部',},
          {id: 1, name: '退回',},
          {id: 2, name: '采购完成',},
        ],
      },
      noDataFlag: false,
      isSort: false,
      checked: false,
      myPurchaseRequestData: [],
      pageClick: true,
      formInline: {
        purchaseRequisitionCode: null,
        trackStatus: null,
        productName: null,
        materielCode: null,
        itemno: null,
        createTimeSort: 'DESC',
        limit: 10, //每页条数
        page: 1, //页码
        total: 0,
        clickQuery: null,
        track: 1,
      },
    };
  },
  methods: {
    handleFilter(val){
      this.formInline.purchaseRequisitionCode = val.purchaseRequisitionCode;
      this.formInline.materielCode = val.materielCode;
      this.formInline.trackStatus = val.trackStatus;
      this.formInline.productName = val.productName;
      this.formInline.page = 1;
      this.queryPurchaseRequestList();
    },
    handleReset(){
      this.formInline = {
        purchaseRequisitionCode: null,
        trackStatus: null,
        productName: null,
        materielCode: null,
        itemno: null,
        createTimeSort: 'DESC',
        limit: 10, //每页条数
        page: 1, //页码
        total: 0,
        clickQuery: null,
        track: 1,
      };
      this.queryPurchaseRequestList();
    },
    toSelect() {
      this.setCurrentMenu(0);
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.pageClick = false;
      this.queryPurchaseRequestList();
    },
    handleSizeChange(val) {
      this.formInline.page = 1;
      this.formInline.limit = val;
      this.pageClick = false;
      this.queryPurchaseRequestList();
    },
    sortChange() {
      this.isSort = !this.isSort;
      this.queryPurchaseRequestList();
    },
    async queryPurchaseRequestList() {
      if (this.isSort) {
        this.formInline.createTimeSort = 'DESC';
      } else {
        this.formInline.createTimeSort = 'ASC';
      }
      if (this.pageClick) {
        this.formInline.clickQuery = 1;
        this.formInline.page = 1;
      } else {
        this.formInline.clickQuery = 0;
      }
      const res = await Api.queryProcurementPlan(this.formInline);
      if (res.code == '200') {
        this.formInline.total = res.data.totalCount;
        this.myPurchaseRequestData = res.data.purchasePlanVOList || [];
        if (!this.myPurchaseRequestData || this.myPurchaseRequestData.length == 0) {
          this.noDataFlag = true;
        } else {
          this.noDataFlag = false;
        }
      }
      this.pageClick = true;
    },
    // 删除已选采购申请
    async deleteSelectedPurchaseRequest() {
      let res = Api.deletePurchaseRequest();
    },
  },
  mounted() {
    this.pageClick = false;
    this.queryPurchaseRequestList();
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/theme.scss';
.order-item {
  background: #fff;
  .generate-order-container {
    padding: 10px 0;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    margin-bottom: 20px;
    ::v-deep .el-form {
      .el-form-item__label {
        color: #333;
      }
      .el-form-item {
        input::-webkit-input-placeholder {
          color: #999;
        }
        input::-moz-input-placeholder {
          color: #999;
        }
        input::-ms-input-placeholder {
          color: #999;
        }
      }
    }

    .button {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      margin-top: 6px;
    }

    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 2px;
        margin-left: 40px;
        .el-form-item__content {
          input {
            width: 200px;
            height: 30px;
            line-height: 30px;
          }

          .el-range-input {
            width: 80px;
          }

          .el-range-separator {
            width: 30px;
          }

          .el-date-editor {
            width: 200px;
          }

          .el-button:focus,
          .el-button:hover {
            color: #333333;
            background-color: transparent;
          }

          .el-checkbox-group {
            margin-left: 70px;
            .is-checked + .el-checkbox__label {
              color: #333333;
            }
          }

          .el-date-editor {
            height: 30px;

            i:nth-child(1) {
              display: none;
            }

            .el-range__close-icon {
              line-height: 22px;
            }

            input {
              height: 25px;
            }

            .el-range-separator {
              height: 25px;
              line-height: 25px;
            }
          }

          .el-button {
            padding: 9px 27px;
          }

          .reset-btn {
            margin: 0 20px 0 80px;
          }
        }
      }
    }
  }
  ::v-deep.el-input__inner {
    border-radius: 0;
    color: #333;
  }
  .generate-order-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 10px 20px;
    border: 1px solid $border-color;
    margin-bottom: 20px;
    box-sizing: border-box;

    ::v-deep .el-checkbox__label {
      font-weight: bold;
      color: #333333;
    }

    .generate-order-top-left {
      display: flex;
      align-items: center;

      .generate-order-top-left-input {
        ::v-deep .el-checkbox {
          .is-checked {
            .el-checkbox__inner {
              background-color: $button-background-color;
            }

            .el-checkbox__inner::after {
              border-color: #333333;
            }
          }

          .is-checked + .el-checkbox__label {
            color: #333333;
          }
        }
      }

      .generate-order-top-left-sort {
        display: flex;
        align-items: center;
        cursor: pointer;

        div {
          margin-left: 40px;
          margin-right: 10px;
        }

        img {
          width: 13px;
          height: 15px;
        }
      }
    }

    .generate-order-top-right {
      display: flex;
      align-items: center;
      cursor: pointer;

      div {
        margin-left: 10px;
      }
    }
  }

  .is-active {
    background-color: #f4f7ff;
  }
  .no-data {
    text-align: center;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
  .generate-order-main {
    .order-item {
      display: flex;
      justify-content: space-between;
      height: 90px;
      padding: 0 20px;
      border: 1px solid $border-color;
      box-sizing: border-box;

      .order-item-main {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        .order-item-left {
          margin-top: 20px;
          box-sizing: border-box;
          line-height: 48px;
          height: 48px;
          // border-right: 1px solid #D9D9D9;
          width: 40px;
          padding-right: 20px;
          text-align: center;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            right: 0;
            width: 1px;
            background: #d9d9d9;
            height: 100%;
          }
        }

        .order-item-middle {
          ul {
            display: flex;
            flex-wrap: wrap;
            width: 900px;

            li {
              display: flex;
              width: 160px;

              &:nth-of-type(4n + 1),
              &:nth-of-type(4n + 2),
              &:nth-of-type(4n + 3) {
                margin-left: 10px;
              }

              .text {
                color: #333;
              }

              .text86 {
                width: 100px;
              }

              .text70 {
                width: 82px;
              }

              .text75 {
                width: 75px;
              }

              .text85 {
                width: 85px;
              }
              .text99 {
                width: 308px;
              }
              .text100 {
                width: 218px;
              }

              .text115 {
                width: 115px;
              }

              .isActive {
                color: #333;
              }

              .text-value {
                color: #333;
              }
              .t-132 {
                width: 132px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .text-value-number {
                width: 80px;
              }

              .text-value-number150 {
                width: 150px;
              }
            }

            li:nth-child(-n + 5) {
              padding: 15px 0;
              box-sizing: border-box;
            }

            .li-width-196 {
              width: 160px;
            }
          }
        }
      }

      .order-item-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .selectBtn {
          width: 80px;
          height: 30px;
          line-height: 26px;
          color: #ea9200;
          text-align: center;
          border: 2px solid #ffa900;
          background: #fff5c7;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }

    .isMainActive {
      background: #f4f7ff;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .pagination-box {
    text-align: right;
  }
}
</style>
